<template>
    <router-view>

    </router-view>

    <Notivue v-slot="item">
        <Notification :theme="pastelTheme"  :item="item" >
            <NotificationProgress :item="item" />
        </Notification>
    </Notivue>
    <div class="row" v-if="loading">
        <div class="col-12 text-center">
			<span class="spinner spinner-border spinner-card flex-shrink-0" id="spinner" role="status"
                  style="height: 5rem; width: 5rem; display: block">
				<span class="visually-hidden"></span>
			</span>
        </div>
    </div>
</template>
<script setup>
import { Notivue, Notification,  pastelTheme, NotificationProgress } from 'notivue';
import {computed} from "vue";
import store from "@/state/store";

const loading = computed(() => {
    return store.state.api.loading
});
</script>
